import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import dashboardReducer from './slices/dashboardSlice';
import paymentsReducer from './slices/paymentsSlice';
import subscriptionsReducer from './slices/subscriptionsSlice';
import customersReducer from './slices/customersSlice';
import apiKeysReducer from './slices/apiKeysSlice';
import notificationsReducer from './slices/notificationsSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    dashboard: dashboardReducer,
    payments: paymentsReducer,
    subscriptions: subscriptionsReducer,
    customers: customersReducer,
    apiKeys: apiKeysReducer,
    notifications: notificationsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;